<template>
  <div class="upload-social-id">
    <upload-simple-id v-if='!biometric'
                      :social-id-upload-url="socialIdUploadUrl"
                      :social-id-files="socialIdFiles"
                      @observe="observe"
                      @unobserve="unobserve"
                      @uploaded="addSocialIdPart"
                      @removed="removeSocialIdPart" />
    <upload-biometric-id v-else
                         :social-id-upload-url="socialIdUploadUrl"
                         :social-id-files="socialIdFiles"
                         @observe="observe"
                         @unobserve="unobserve"
                         @uploaded="addSocialIdPart"
                         @removed="removeSocialIdPart" />

    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import UploadSimpleId from '@/components/meitav-dash/open-fund/UploadSimpleId';
import UploadBiometricId from '@/components/meitav-dash/open-fund/UploadBiometricId';
import { SocialIdType } from '@/constants/meitav-dash/open-fund';

export default {
  name: 'UploadSocialId',
  components: { UploadBiometricId, UploadSimpleId, DefaultButton },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['socialIdType', 'socialIdFiles']),
    socialIdUploadUrl() {
      return '/api/saving/upload-id';
    },
    biometric() {
      return this.socialIdType === SocialIdType.BIOMETRIC;
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['addSocialIdPart', 'removeSocialIdPart']),
  },
};
</script>

<style scoped lang="scss">
.upload-social-id {

  .uploader {
    width: 100% ;
  }
}

</style>
